import React from "react";
import PropTypes from "prop-types";
import { Alert, Button } from "reactstrap";
import { Link } from "react-router-dom";
import CloseBannerIcon from "components/Images/CloseBannerIcon";
import BannerStarGroup from "components/Images/BannerStarGroup";

const Banner = ({ handleBannerClick }) => {
  return (
    <div className="site__banner" alert="none">
      <Alert
        className="site__banner-container"
        onClose={() => handleBannerClick()}
        dismissible="true"
      >
        <BannerStarGroup />
        <div className="site__banner-text-container">
          <p className="site__banner-text">
            We&apos;ve updated! Still need to access purchases made on the old
            store? <Link to="/faq"> Learn More</Link>
          </p>
        </div>
        <div className="site__banner-button-container-container">
          <div className="site__banner-button-container">
            <Button
              className="banner-close-button"
              aria-label="Close Button"
              onClick={() => handleBannerClick()}
            >
              <CloseBannerIcon onClick={() => handleBannerClick()} />
            </Button>
          </div>
        </div>
      </Alert>
    </div>
  );
};

Banner.propTypes = {
  handleBannerClick: PropTypes.func.isRequired
};

export default Banner;
